// --- START OF FILE src/pages/AboutUs.jsx ---

import React from 'react';
import { useTranslation } from 'react-i18next'; // MODIFICACIÓN: Importar useTranslation
// Ajusta la ruta si Global.css está en una ubicación diferente relativa a este archivo
import '../styles/Global.css'; 

const AboutUs = () => {
  const { t } = useTranslation(); // MODIFICACIÓN: Hook de traducción

  return (
    <div>
      <h1 className="page-title"> 
        {t('aboutUsPageTitle')} {/* MODIFICACIÓN */}
      </h1>

      <p className="body-text">
        {t('aboutUsParagraph1')} {/* MODIFICACIÓN */}
      </p>

      <p className="body-text">
        {t('aboutUsParagraph2')} {/* MODIFICACIÓN */}
      </p>

      <p className="body-text">
        {t('aboutUsParagraph3')} {/* MODIFICACIÓN */}
      </p>
    </div>
  );
};

export default AboutUs;
// --- END OF FILE src/pages/AboutUs.jsx ---